var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page--main",class:[
    {'js-scrollToMap' : _vm.$store.state.auth.login},
    {'messageCenterOpen' : this.$store.state.messageCenter.status}
    ]},[_c('mainBlock'),_c('HelloUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }